module.exports = __webpack_public_path__ + "assets/img/contractcomparsion-func2.aaa38901.png";